/** Varianta de model potrivită dispozitivului: „mobile” sau „desktop”, cu suprascriere din setări. */
export type Variant = 'mobile' | 'desktop';
const KEY = 'car-variant';

export function autoVariant(nav: { userAgent: string; maxTouchPoints?: number; deviceMemory?: number }, coarsePointer: boolean): Variant {
  const mobileUA = /iPhone|iPad|iPod|Android/.test(nav.userAgent) || (/Macintosh/.test(nav.userAgent) && (nav.maxTouchPoints ?? 0) > 1);
  if (mobileUA || coarsePointer) return 'mobile';
  if (nav.deviceMemory !== undefined && nav.deviceMemory <= 4) return 'mobile';
  return 'desktop';
}

export function chosenVariant(): Variant {
  let saved: string | null = null;
  try { saved = localStorage.getItem(KEY); } catch { saved = null; }
  if (saved === 'mobile' || saved === 'desktop') return saved;
  return autoVariant(navigator as Navigator & { deviceMemory?: number }, matchMedia('(pointer: coarse)').matches);
}

export function saveVariant(v: Variant | 'auto'): void {
  try { if (v === 'auto') localStorage.removeItem(KEY); else localStorage.setItem(KEY, v); } catch { /* fără stocare */ }
}
